module.exports = ".advanced-search {\n    border-bottom: 1px solid #edf0f4;\n    margin: -0.5em 1.5em 1em 0;\n    padding-bottom: 1em;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/manutencoes/ordens-servico/ordem-servico-list/ordem-servico-list.component.css
 ** module id = 425
 ** module chunks = 0
 **/